import {axios} from "../../../lib";

export const updateCompanySettings = ({cif, monthClosureTimestamp}) => {
    return axios.put("/settings", {cif: cif, monthClosureTimestamp: monthClosureTimestamp})
        .then((response) => {

            return {success: true, message: `Setarea salvată cu success`};
        })
        .catch((error) => {
            console.error("Eroare API:", error);
            return {success: false, message: 'A apărut o problemă la efectuarea acțiunii'};
        });
};
